

require('./comment_approval');

require('./switch-in-table');

require('./multilingual-selector');

require('./url-selector');

require('./settings-fields');